import React from "react";

export default function IconButton({
  className = "",
  onClick,
  children,
  type = "button",
  disabled = false,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`p-2 rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
